import { Component, input } from '@angular/core';
import { NuggetEvent } from 'src/app/shared/models/nugget-event.model';

@Component({
  selector: 'app-weekly-nugget',
  templateUrl: './weekly-nugget.component.html',
  styleUrls: ['./weekly-nugget.component.scss'],
  standalone: false,
})
export class WeeklyNuggetComponent {
  readonly nugget = input<NuggetEvent>(undefined);
}
